module.exports = __webpack_public_path__ + "static/img/banner.616983b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/banner.jpg
// module id = z/m2
// module chunks = 0